import type { HelpFile } from '../../types/help'
import { ParameterEditorTestIds } from '../../../testids/ParameterEditorTestIds'

export const parameterEditorHelp: HelpFile = {
  docPage: '/docs/reporting/parameters',
  texts: {
    [ParameterEditorTestIds.parameterDefinitionEditor]:
      'Parameter dieses Berichts oder dieser Abfrage — jeder hat einen Namen und Werttyp und wird im SQL über seinen Namen referenziert.',
    [ParameterEditorTestIds.paramDefNewName]:
      'Name des neuen Parameters — nur Buchstaben, Ziffern und Unterstriche erlaubt.',
    [ParameterEditorTestIds.btnAddParameter]: null,
  },
}
